export const LOAD_ALL_EMAIL_TEMPLATES = 'LOAD_ALL_EMAIL_TEMPLATES';
export const REMOVE_EMAIL_TEMPLATE_BY_ID = 'REMOVE_EMAIL_TEMPLATE_BY_ID';
export const ERROR_GETTING_EMAIL_TEMPLATES = 'ERROR_GETTING_EMAIL_TEMPLATES';
export const LOAD_EMAIL_TEMPLATE_BY_ID = 'LOAD_EMAIL_TEMPLATE_BY_ID';
export const ERROR_LOAD_EMAIL_TEMPLATE_BY_ID = 'ERROR_LOAD_EMAIL_TEMPLATE_BY_ID';
export const EDIT_EMAIL_TEMPLATE_BY_ID = 'EDIT_EMAIL_TEMPLATE_BY_ID';
export const ERROR_EDIT_EMAIL_TEMPLATE_BY_ID = 'ERROR_EDIT_EMAIL_TEMPLATE_BY_ID';

export function loadAllEmailTemplates(data) {
  return {
    type: LOAD_ALL_EMAIL_TEMPLATES,
    payload: data,
  }
}

export function removeEmailTemplateById(data) {
  return {
    type: REMOVE_EMAIL_TEMPLATE_BY_ID,
    payload: data,
  }
}

export function errorGettingEmailTemplate(data) {
  return {
    type: ERROR_GETTING_EMAIL_TEMPLATES,
    payload: data,
  }
}

export function loadEmailTemplateById(data) {
  return {
    type: LOAD_EMAIL_TEMPLATE_BY_ID,
    payload: data,
  }
}

export function errorGettingEmailTemplateById(data) {
  return {
    type: ERROR_LOAD_EMAIL_TEMPLATE_BY_ID,
    payload: data,
  }
}

export function editEmailTemplate(data) {
  return {
    type: EDIT_EMAIL_TEMPLATE_BY_ID,
    payload: data,
  }
}

export function errorEditEmailTemplate(data) {
  return {
    type: ERROR_EDIT_EMAIL_TEMPLATE_BY_ID,
    payload: data,
  }
}


// WEBPACK FOOTER //
// ./src/actions/emailTemplate/index.js